"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _SVGIcon = _interopRequireDefault(require("@instructure/ui-svg-images/lib/components/SVGIcon"));

var _ref =
/*#__PURE__*/
_react.default.createElement("path", {
  d: "M1581.176 1072.47h-225.882v438.551l-366.833 213.685c-17.506 10.278-39.416 10.278-56.922 0L564.706 1511.02v-438.55H338.824V685.647c0-20.103 10.842-38.739 28.009-48.79l310.814-181.045v164.894h564.706V455.812l310.814 181.044c17.167 10.052 28.01 28.688 28.01 48.791v386.824zm112.942 0V685.648c0-60.085-32.189-116.216-84.142-146.485L1242.353 325.14V56H677.647v269.139L310.024 539.162c-51.953 30.269-84.142 86.4-84.142 146.485v386.824H0v564.705h557.026l317.703 185.111c26.429 15.36 55.68 23.04 85.271 23.04 29.59 0 58.955-7.68 85.27-23.04l317.704-185.11H1920V1072.47h-225.882z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconModule =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(IconModule, _Component);

  function IconModule() {
    (0, _classCallCheck2.default)(this, IconModule);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IconModule).apply(this, arguments));
  }

  (0, _createClass2.default)(IconModule, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_SVGIcon.default, Object.assign({}, this.props, {
        name: "IconModule",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);
  IconModule.displayName = "IconModule";
  return IconModule;
}(_react.Component);

exports.default = IconModule;
IconModule.glyphName = 'module';
IconModule.variant = 'Solid';
IconModule.propTypes = (0, _objectSpread2.default)({}, _SVGIcon.default.propTypes);